import React from "react";

import { toAbsoluteUrl } from "../../../_helpers";
import { TopActions } from "../subheader/components/TopActions";

export function Brand() {
  return (
    <>
      {/* begin::Brand */}
      <div
        className="aside-brand d-none d-lg-flex justify-content-between pl-3 py-3 py-lg-5 border-bottom position-fixed w-100 bg-dark"
        style={{ zIndex: 99 }}
      >
        <div className="flex-grow-1">
          {/* begin::Logo */}
          <div className="brand-logo">
            <img
              alt="logo"
              src={toAbsoluteUrl("/media/logos/jaisalmer-trust-logo.png")}
              style={{ width: "4%" }}
            />
          </div>
          {/* end::Logo */}
        </div>
        <TopActions />
      </div>
      {/* end::Brand */}
    </>
  );
}
